import { GiftAvailableUserIdGetInputModel } from "../../api/v1/gift/available/[user_id]/GetInputModel"
import { GetGiftAvailableUserId } from "../../api/v1/gift/available/[user_id]/get"
import { UserReceivingGiftConditions } from "./UserReceivingGiftConditions"
import { adaptUserReceivingGiftConditions } from "./adaptUserReceivingGiftConditions"

export const fetchUserReceivingGiftConditions = (
  userId: string,
): Promise<UserReceivingGiftConditions> => {
  const model = new GiftAvailableUserIdGetInputModel({ userId })

  return GetGiftAvailableUserId(model).then((res) =>
    adaptUserReceivingGiftConditions(userId, res),
  )
}
